// reducers/employee-onboarding/direct.js

export function directHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_DIRECT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function directIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_DIRECT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function direct(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_DIRECT_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}